const tracksPT = {
    "view": {
        "table": {
            "title": "Editar Faixas",
            "column": {
                "name": "Nome",
                "mixName": "Nome do Mix",
                "mixLength": "Duração do Mix",
                "player": "Reprodutor",
                "status": "Status",
                "accStatus": "Status da Conta",
                "qc": "QC",
                "action": "Ação"
            },
            "button": {
                "edit": "Editar",
                "goToReleases": "Ir para Lançamentos",
                "distribute": "Distribuir",
                "submitEditing": "Enviar Edição",
                "statusReady": "Pronto",
                "statusNotReady": "Não Pronto"
            },
            "message": {
                "identityNotCheckedTooltip": "Você ainda não forneceu suas informações completas, portanto, não pode distribuir os lançamentos. Para isso, por favor, Envie Suas Informações.",
                "tracksNotReadyTooltip": "Por favor, envie os metadados de todas as Faixas para Distribuir o Lançamento.",
                "tracksNotReadyForEditingTooltip": "Por favor, envie os metadados de todas as faixas para Enviar as Edições.",
                "distributionDisabledPreScanInProgressTooltip": "Por favor, aguarde o pre-scan ser concluído primeiro para distribuir o lançamento.",
                "distributionDisabledPreScanNotDoneTooltip": "Por favor, execute o pre-scan primeiro para distribuir o lançamento.",
                "distributionDisabledPreScanDeclarationNotSubmittedTooltip": "Por favor, envie a declaração do pre-scan primeiro para distribuir o lançamento.",
                "browserNotSupported": "Seu navegador não suporta o elemento de áudio.",
                "trackUpdated": "Faixa foi atualizada!"
            },
            "modal": {
                "distribute": {
                    "header": "Você tem certeza de que todas as informações inseridas são válidas e representam totalmente este lançamento?",
                    "body": {
                        "point1": "Após esta ação, seu lançamento será verificado e, se as informações estiverem corretas, será distribuído nas datas oficiais e exclusivas de distribuição.",
                        "point2": "Ao confirmar e aceitar este formulário, você está aceitando e cumprindo totalmente os <1>Termos de Distribuição</1>, <3>Termos de Uso</3> e <5>Política de Privacidade</5>.",
                        "point3": "Ao confirmar e aceitar este formulário, você está confirmando indiscutivelmente que o conteúdo do lançamento submetido com os ativos pertencentes, arquivos de áudio e metadados, pertencem exclusivamente a você ou estão totalmente licenciados para sua gravadora.",
                        "point4": "Por meio deste, você aceita totalmente que será o único responsável por qualquer informação enganosa, uso não licenciado, atividade ilegal ou qualquer tipo de disputa.",
                        "flaggedTracksTerms": {
                            "header": "Termos das Faixas Marcadas",
                            "point1": "Por favor, note: <strong>'{{releaseName}}'</strong> contém uma ou mais faixas marcadas. Uma taxa de <strong>15 €</strong> por faixa marcada se aplica para entregar o lançamento ao <strong>Spotify</strong>. Como você optou por não pagar essa taxa neste momento, o lançamento não será entregue ao Spotify. Ao confirmar e aceitar este formulário, você reconhece e aceita estes termos.",
                            "point2": "No futuro, se você optar por entregar o lançamento ao <strong>Spotify</strong>, poderá ir à seção Marcada na tabela de Lançamentos e seguir as instruções de pagamento."
                        },
                        "artificialStreamingDeclaration": {
                            "header": "Declaração de Streaming Artificial",
                            "point1": "<strong>1.</strong> Eu entendo e concordo plenamente em não me envolver em qualquer forma de streaming artificial, incluindo o uso de bots, fazendas de streaming ou qualquer método que manipule métricas de DSP.",
                            "point2": "<strong>2.</strong> Eu não pagarei ou oferecerei pagamento por colocações em playlists, nem trabalharei com terceiros que prometam colocações garantidas — eu entendo que isso é considerado fraude e golpe.",
                            "point3": "<strong>3.</strong> Eu reconheço que quaisquer ações desse tipo podem resultar em rescisão imediata, perda de royalties, reivindicações legais, penalidades contratuais e taxas, e relatórios para DSPs e autoridades.",
                            "point4": "<strong>4.</strong> Eu também garanto informar e educar quaisquer artistas ou clientes com quem trabalho sobre essas regras e garantir que eles cumpram.",
                            "point5": "<strong>5.</strong> Eu entendo que, se me envolver em streaming artificial, meus dados KYC, incluindo meu nome completo, endereço, carteira de identidade e outras informações pessoais, podem ser compartilhados com os departamentos legais dos DSPs, como os do Spotify, Apple Music e outros.",
                            "point6": "<strong>6.</strong> Eu aceito total responsabilidade legal por quaisquer violações.",
                            "acknowledgment": "Eu, por meio deste, reconheço e concordo em cumprir os termos acima de Streaming Artificial, e aceito total responsabilidade legal por quaisquer violações."
                        }
                    },
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar e Aceitar"
                    }
                },
                "finishEditing": {
                    "header": "Você tem certeza de que todas as informações inseridas são válidas e representam totalmente este lançamento?",
                    "body": {
                        "point1": "Após esta ação, seu lançamento será verificado e, se as informações estiverem corretas, será redistribuído para os parceiros DSP. <strong>NOTA, apenas METADADOS serão enviados para DSPs, conteúdos como arquivos de IMAGEM e ÁUDIO não podem ser atualizados desta forma.</strong>",
                        "point2": "Ao confirmar e aceitar este formulário, você está aceitando e cumprindo totalmente os <1>Termos de Uso</1> e os Termos do nosso Acordo de Distribuição Exclusiva.",
                        "point3": "Ao confirmar e aceitar este formulário, você está aceitando e cumprindo totalmente a <1>Política de Privacidade</1>.",
                        "point4": "Ao confirmar e aceitar este formulário, você está confirmando indiscutivelmente que o conteúdo do lançamento submetido com os ativos pertencentes, arquivos de áudio e metadados, pertencem exclusivamente a você ou estão totalmente licenciados para sua gravadora.",
                        "point5": "Por meio deste, você aceita totalmente que será o único responsável por qualquer informação enganosa, uso não licenciado, atividade ilegal ou qualquer tipo de disputa."
                    },
                    "button": {
                        "cancel": "Cancelar",
                        "confirm": "Confirmar e Aceitar"
                    }
                }
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "title": "Editar faixa {{trackName}}",
                "mandatoryMetadata": "Metadados Obrigatórios",
                "required": "Obrigatório",
                "trackName": "Nome da Faixa",
                "mixName": "Nome do Mix",
                "originalmix": "Mix Original",
                "remix": "Este é um Remix ou Mix",
                "vocals": "Vocais",
                "genre": "Gênero",
                "subGenre": "Subgênero",
                "additionalMetadata": "Metadados Adicionais",
                "copyright": "Direitos Autorais ©",
                "copyrightYear": "Ano dos Direitos Autorais",
                "albumOnly": "Apenas Álbum",
                "explicitContent": "Conteúdo Explícito",
                "isrc": "ISRC",
                "daIsrc": "ISRC Dolby Atmos",
                "generateIsrc": "Gerar ISRC",
                "trackLanguageMetadata": "Metadados de Idioma da Faixa",
                "language": "Idioma",
                "autoDetectLanguage": "Detecção Automática (Idioma)",
                "accountingData": "Dados Contábeis",
                "labelShare": "Participação da Gravadora (%)"
            },
            "placeholder": {
                "select": "Selecionar...",
                "labelShare": "ex. 50"
            },
            "help_text": {
                "trackName": "Título da faixa",
                "mixName": "Insira o nome do mix sem colchetes. Algumas faixas são lançadas em mais de uma versão. Este campo descreve a versão, por exemplo, 'Bunte Bummler - Aesub (Monika Ross Remix)",
                "vocals": "Ouça sua faixa na íntegra. Se sua faixa tiver vocais, selecione o idioma dos vocais. Se sua faixa estiver livre de vocais, selecione a opção Instrumental. Verifique novamente para ter certeza. Se esta entrada estiver errada, algumas lojas como iTunes e Apple Music rejeitarão o lançamento.",
                "publishers": {
                    "publisherName": "<strong>Nome do editor:</strong> Insira o nome completo da empresa de publicação se estiver usando serviços de publicação.  Se não estiver usando serviços de publicação oficiais, insira/selecione <strong>Controle de Direitos Autorais</strong>. Por favor, <strong>não insira o nome da sua gravadora</strong> se não for uma empresa de publicação registrada. Implicações legais podem se aplicar.",
                    "authorSongWriterName": "<strong>Nome completo do autor/compositor:</strong> Insira o <strong>nome e sobrenome reais</strong> da pessoa."
                },
                "contributors": {
                    "contributorsName": "<strong>Nome dos colaboradores:</strong> Insira o <strong>nome e sobrenome reais</strong> da pessoa.",
                    "contributorsRoles": "<strong>Funções dos colaboradores:</strong> Pelo menos um colaborador deve ser adicionado como <strong>Compositor</strong>. Se sua faixa tiver vocais, pelo menos um colaborador deve ser adicionado como <strong>Compositor</strong> e um colaborador deve ser adicionado como <strong>Letrista</strong>."
                },
                "copyright": "Nome do titular dos direitos autorais",
                "albumOnly": "Indica se a faixa será vendida apenas como parte de um lançamento em pacote. Note que algumas lojas podem ignorar esta instrução",
                "explicitContent": "Marque este campo se a faixa tiver letras proibidas",
                "isrc": "O Código Internacional de Gravação Padrão atribuído à faixa. Se você não tiver o seu próprio, nós geraremos um para você",
                "daIsrc": "O Código Internacional de Gravação Padrão atribuído à faixa. Se você não tiver o seu próprio, nós geraremos um para você",
                "language": "Em qual idioma o nome da faixa está escrito? Verifique novamente se não tiver certeza. Se esta entrada estiver errada, algumas lojas como iTunes e Apple Music rejeitarão o lançamento.",
                "labelShare": "<strong>Dica:</strong> O padrão da indústria para <strong>participação da gravadora</strong> é <strong>50%</strong> e <strong>50%</strong> para os <strong>acionistas</strong>. Aconselhamos fortemente que você insira a porcentagem de participação precisa com a qual concordou com seus artistas, acionistas e parceiros.",
                "costTypes": {
                    "point1": "Insira apenas <strong>Custos</strong> reais, ocorridos ou pré-acordados por faixa. Aconselhamos fortemente que você não insira custos falsos.",
                    "point2": "<strong>Tipos de custo</strong> podem ser quaisquer custos fixos ou variáveis, ou seja, <strong>Masterização de Áudio, Design Gráfico, Promoção, Marketing</strong>, ou qualquer outra despesa viável gasta para a <strong>Faixa</strong> específica pela <strong>Gravadora</strong>."
                }
            },
            "button": {
                "submitTrack": "Enviar Faixa"
            },
            "message": {
                "successArtistAdded": "Um novo Artista foi adicionado!",
                "successPublisherAdded": "Um novo Editor foi adicionado!",
                "successContributorAdded": "Um novo Colaborador foi adicionado!",
                "successShareholderAdded": "Um novo Acionista foi adicionado!",
                "successCostTypeAdded": "Um novo Tipo de Custo foi adicionado!",
                "errorLabelShareInvalid": "Por favor, insira um valor válido (1-100)",
                "errorFormCannotBeSubmitted": "O formulário não pode ser enviado! Por favor, preencha todos os campos e verifique os erros!",
                "accountingMetadata": {
                    "title": "AVISO",
                    "description": {
                        "point1": "METADADOS OPCIONAIS - preencha esta parte dos metadados apenas se você emitir relatórios contábeis para seus artistas ou acionistas!",
                        "point2": "Por favor, certifique-se de que os dados submetidos nesta seção sejam totalmente precisos, pois afetarão os relatórios que você enviará para seus artistas e acionistas.",
                        "point3": "Recomendamos fortemente que você verifique novamente as entradas, pois após o envio, edições adicionais e mudanças não são recomendadas para a precisão dos dados.",
                        "point4": "Relatórios contábeis para seus artistas e acionistas terão um efeito preciso apenas se você enviar todos os parâmetros corretamente e de acordo com seus acordos com seus artistas e acionistas.",
                        "point5": "Os custos podem ser adicionados apenas uma vez e não podem ser editados posteriormente por razões de transparência e precisão. Certifique-se de inserir todos os custos da faixa com precisão na sua primeira tentativa."
                    }
                }
            }
        }
    },
    "publishersRow": {
        "form": {
            "label": {
                "publishers": "Editores",
                "required": "Obrigatório",
                "order": "Ordem",
                "publisherName": "Nome do Editor",
                "authorSongWriterName": "Nome completo do Autor/Compositor"
            },
            "placeholder": {
                "publisherName": "Selecionar Editor..."
            },
            "button": {
                "addAnother": "Adicionar outro",
                "createNew": "Criar novo?",
                "remove": "Remover"
            },
            "message": {
                "publisherRequired": "Por favor, selecione o editor",
                "authorSongWriterRequired": "Por favor, insira o nome e sobrenome reais da pessoa."
            },
            "modal": {
                "header": "Adicionar novo Editor",
                "body": {
                    "label": {
                        "name": "Nome"
                    },
                    "message": {
                        "nameRequired": "Nome é obrigatório",
                        "publisherAlreadyExists": "Editor já existe"
                    }
                },
                "button": {
                    "createNew": "Criar novo",
                    "cancel": "Cancelar"
                }
            }
        }
    },
    "contributorsRow": {
        "form": {
            "label": {
                "contributors": "Colaboradores",
                "required": "Obrigatório",
                "order": "Ordem",
                "contributorName": "Nome completo do Colaborador",
                "contributorRole": "Função do Colaborador"
            },
            "placeholder": {
                "contributorName": "Selecionar Colaborador..."
            },
            "button": {
                "addAnother": "Adicionar outro",
                "createNew": "Criar novo?",
                "remove": "Remover"
            },
            "modal": {
                "header": "Adicionar novo Colaborador",
                "body": {
                    "label": {
                        "name": "Nome"
                    },
                    "help_text": {
                        "name": "Por favor, insira o nome e sobrenome completos do compositor. Exemplo: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Nome é obrigatório",
                        "nameMustNotBeInUppercase": "Nome não deve estar todo em maiúsculas",
                        "insertRealName": "Por favor, insira o nome e sobrenome reais da pessoa.",
                        "errorContributorAlreadyExists": "Colaborador já existe"
                    }
                },
                "button": {
                    "createNew": "Criar novo",
                    "cancel": "Cancelar"
                }
            }
        }
    },
    "shareholdersRow": {
        "form": {
            "label": {
                "order": "Ordem",
                "shareholders": "Acionistas",
                "shareholderName": "Nome do Acionista",
                "shareholderSplit": "Divisão do Acionista (%)",
                "shareholderRoles": "Funções do Acionista"
            },
            "placeholder": {
                "shareholderName": "Selecionar Acionista...",
                "shareholderSplit": "ex. 50"
            },
            "message": {
                "shareholderRequired": "Por favor, selecione o acionista",
                "shareholderSplitRequired": "Por favor, insira um valor válido (1-100)",
                "shareholderRolesRequired": "Por favor, selecione pelo menos uma função",
                "shareSum": "A Participação da Gravadora e as Divisões dos Acionistas devem somar 100%"
            },
            "button": {
                "addAnother": "Adicionar outro",
                "createNew": "Criar novo?",
                "remove": "Remover"
            },
            "modal": {
                "header": "Adicionar novo Acionista",
                "body": {
                    "label": {
                        "name": "Nome",
                        "email": "Email"
                    },
                    "help_text": {
                        "name": "Por favor, insira o nome e sobrenome completos do compositor. Exemplo: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Nome é obrigatório",
                        "emailRequired": "Email é obrigatório",
                        "emailInvalid": "Email não é válido"
                    }
                },
                "button": {
                    "createNew": "Criar novo",
                    "cancel": "Cancelar"
                }
            }
        }
    },
    "costTypesRow": {
        "form": {
            "label": {
                "costTypes": "Tipos de Custo",
                "order": "Ordem",
                "costType": "Tipo de Custo",
                "cost": "Custo (€)"
            },
            "placeholder": {
                "costType": "Selecionar Tipo de Custo...",
                "cost": "ex. -7.5"
            },
            "button": {
                "addAnother": "Adicionar outro",
                "createNew": "Criar novo?",
                "remove": "Remover"
            },
            "message": {
                "costTypeRequired": "Por favor, selecione o tipo de custo",
                "costNotNegative": "Por favor, insira um valor negativo, ex. -10.0"
            },
            "modal": {
                "header": "Adicionar Novo Tipo de Custo",
                "body": {
                    "label": {
                        "name": "Nome"
                    },
                    "message": {
                        "nameRequired": "Nome é obrigatório",
                        "costTypeAlreadyExists": "Tipo de custo já existe"
                    },
                    "button": {
                        "createNew": "Criar novo",
                        "cancel": "Cancelar"
                    }
                }
            }
        }
    }
};

export default tracksPT;